import { Box, Grid2 as Grid, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";

import { useListProductUpdatesQuery } from "api/memberPortal/product/productUpdate/productUpdate.api";
import {
  usePclProductCheckQuery,
  usePclProductQuery,
} from "api/public/project/product/product.api";
import Subheader from "components/Subheader";
import { usePageTitle } from "hooks/usePageTitle";

import ProductContent from "./components/ProductContent/ProductContent";
import ProductSidebar from "./components/ProductSidebar/ProductSidebar";
import ProductUpdates from "./components/ProductUpdates/ProductUpdates";

export default function CheckProductPermDetails() {
  const { id } = useParams();

  const { data: hasPerm, isLoading } = usePclProductCheckQuery(id ?? skipToken);

  if (isLoading) return null;

  if (hasPerm === true) {
    return <ProductDetails />;
  }

  // TODO: Make this better plz :(
  return <div>Product does not exist or is not viewable on the PCL.</div>;
}

const ProductDetails = () => {
  const { id } = useParams();
  usePageTitle("NIAP - Product Details");

  const { data: productUpdates = [] } = useListProductUpdatesQuery(
    id ? { parentId: id, active: true } : skipToken,
  );
  const { data: project } = usePclProductQuery(id ?? skipToken);

  const isCertified = project?.certification_status === "Certified";

  return (
    <>
      <Subheader pageName={"Products"} />
      <Typography variant="h1" textAlign="center" mt={4}>
        {`Compliant Product - ${isCertified ? project.product_name : "EVALUATION"}`}
      </Typography>
      <Box padding={5} paddingTop={3}>
        <Grid container spacing={3}>
          <Grid size={{ sm: 12, md: 2 }}>
            <ProductSidebar />
          </Grid>

          <Grid size={{ sm: 12, md: 7 }} flex={1}>
            <ProductContent project={project} />
          </Grid>

          <Grid size={{ sm: 12, md: 3 }}>
            <Typography variant="h3" textAlign="center">
              Product Updates
            </Typography>

            <ProductUpdates productUpdates={productUpdates} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
